export default __webpack_public_path__ + "static/media/KOD0118-min.634e4b04.webp";